export const demoColumns = [
  { key: 'name', title: 'Name' },
  { key: 'type', title: 'Type (jpg, png, zip etc.)' },
  { key: 'size', title: 'Size ' },
  { key: 'created_at', title: 'Created Date' },
  { key: 'content_id', title: 'Content ID' }
]

export const formattedData = [
  {
    name: 'pic11.zip',
    type: 'application/zip',
    size: '0.29MB',
    created_at: 'June 26, 2024, 11:34:47',
    content_id: 'bafybeicclcdj3opiobfvdm45h7aeku4owizymcgltffhg7fgv5mrk6sjfu'
  },
  {
    name: 'pic12.zip',
    type: 'application/zip',
    size: '0.29MB',
    created_at: 'June 26, 2024, 11:34:08',
    content_id: 'bafybeia5nl2mtvutotghoctjeznhy2ct46dqmpvxtydoj5uyfrcfvz2y44'
  }
]
